/** Format decimal hours from the API, without presenting missing data as zero. */
export function formatDurationHours(value: number | string | null | undefined): string {
	if (value == null) return '—';

	if (typeof value === 'string') {
		value = value.trim();
		if (!/^\d+(?:\.\d+)?$/.test(value)) return '—';
	}

	const hours = Number(value);
	const totalMinutes = Math.round(hours * 60);
	if (!Number.isFinite(hours) || hours < 0 || !Number.isSafeInteger(totalMinutes)) return '—';

	const wholeHours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	if (minutes === 0) return `${wholeHours} h`;
	if (wholeHours === 0) return `${minutes} min`;
	return `${wholeHours} h ${minutes} min`;
}
